import Blue from "~/core";
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

new Blue({
	name: 'Video Slideshow',
	selector: ".video-swiper",
	setup(registration) {
    // Swiper.use() is no longer needed in Swiper 9+
    const swiper = new Swiper(registration, {
      modules: [Navigation, Autoplay],
      direction: 'horizontal',
      // slidesPerView: 3,
      // spaceBetween: 30,
      breakpoints: {
          1: {
              slidesPerView: 1.5,
              spaceBetween: 30,
          },
          576: {
            slidesPerView: 2.5,
            spaceBetween: 30,
          },
          900: {
              slidesPerView: 3.5,
              spaceBetween: 30,
          }
        },
      loop: false,
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
    });
	}
});